
<template>
  <div id="login" class="login-bg">
    <el-row type="flex" align="middle" :style="{'min-height':pageHeight+'px'}">
      <el-col :span="24">
        <div class="login-box">
          <el-form id="login-form" ref="form" v-model="login_form" label-width="0px" style="color: black">
            <el-form-item label="">
              <div class="login-title" style="font-size: 30px">
                智慧养老服务管理平台
              </div>
            </el-form-item>
            <el-form-item label="" >
              <div style="font-size: 16px">
                用户账号
              </div>
              <el-input prefix-icon="el-icon-user" class="required" v-model="login_form.username"
                        placeholder="请输入用户名"  style="font-size: 16px"></el-input>
            </el-form-item>
            <el-form-item id="password" label="">
              <div style="font-size: 16px">
                密码
              </div>
              <el-input prefix-icon="el-icon-unlock" class="required" v-model="login_form.password" type="password"
                        placeholder="请输入密码" style="font-size: 16px"></el-input>
            </el-form-item>
            <el-form-item style="text-align: center">
              <!--                        <el-button type="primary" @click="onRegister">注册</el-button>-->
              <el-button class="login-btn" type="primary" @click="getData11" style="font-size: 16px">登录</el-button>
            </el-form-item>

            <el-form-item style="text-align: center">
              <div class="com-info">
                <div>
                  <span>©{{year}} 佛山市永爱睦家科技有限公司版权所有</span>
                </div>
                <div>
                  <a href="https://beian.miit.gov.cn" target="_blank">粤ICP备2021053305号</a>
                </div>
              </div>
            </el-form-item>

          </el-form>
        </div>
      </el-col>
    </el-row>
    <el-dialog v-if="registerDialogVisible" title="注册"
               :visible.sync="registerDialogVisible"
               width="30%"
               :show-close="false" :close-on-click-modal="false">
      <el-form id="register-form" ref="registerForm" :rules="registerRules" :model="registerForm" label-width="80px"
               style="color: black">
        <el-form-item label="手机号" prop="phoneNumber">
          <el-input v-model.number="registerForm.phoneNumber" placeholder="请输入手机号">
            <el-button slot="append" @click="sendMsg" :loading="allowedSendSms" >{{sendText}}</el-button>
          </el-input>
        </el-form-item>
        <el-form-item label="验证码" prop="verificationCode">
          <el-input v-model.number="registerForm.verificationCode" placeholder="请输入验证码"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
            <el-button @click="registerDialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="loginByPhone">确 定</el-button>
        </span>
    </el-dialog>
  </div>

</template>


<script>
import {postRequest} from '@/api/login';
import $ from 'jquery'
import { initLoginCache, cacheLoginPageState, clearSensitiveData, preloadLoginResources, getCacheStats } from '@/utils/login-cache'

export default {
  name: "login",
  data: function () {
    return {
      year:new Date().getFullYear(),
      pageHeight: 0,
      login_form: {
        phone: "",
        password: ""
      },
      registerDialogVisible: false,
      registerForm: {
        phoneNumber: "",
        verificationCode: null
      },
      registerRules: {
        phoneNumber: [
          {required: true, message: '请输入手机号', trigger: 'blur'},
          {pattern: /^1[3|4|5|7|8]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur'}
        ],
        verificationCode: [
          {required: true, message: '请输入验证码', trigger: 'blur'},
          {pattern: /^\d{6}$/, message: '验证码格式不正确', trigger: 'blur'}
        ]
      },
      allowedSendSms:false,
      sendText:"发送"
    }
  },
  mounted: function () {
    let me = this;

    // 清除上次登录的敏感数据
    clearSensitiveData();
    
    // 预加载静态资源
    preloadLoginResources();
    
    // 尝试从缓存恢复页面状态
    const cachedState = initLoginCache();
    if (cachedState) {
      Object.assign(this.$data, cachedState);
      console.log('[LoginPage] 已从缓存恢复页面状态');
    }
    
    me.initPageHeight();
    window.onresize = function () {
      me.initPageHeight();
    };
    
    // 绑定键盘事件
    $("#password").bind("keydown", function (e) {
      // 兼容FF和IE和Opera
      let theEvent = e || window.event;
      let code = theEvent.keyCode || theEvent.which || theEvent.charCode;
      if (code == 13) {
        //回车执行查询
        me.onSubmit();
      }
    });
    
    // 登录页加载完成，保存缓存
    this.$nextTick(() => {
      cacheLoginPageState(this.$data);
      const stats = getCacheStats();
      console.log('[LoginPage] 缓存统计信息:', stats);
    });
  },

  created () {
    // 绑定事件
    window.addEventListener('keydown', this.keyDown)
  },
  methods: {

    keyDown (e) {
      // 如果是回车则执行登录方法
      if (e.keyCode === 13) {
        this.getData11()
      }
    },


    getData11(){
      let loginInfo = this.login_form;
      if (!loginInfo.username) {
        this.$message.error("请输入用户名");
        return;
      }
      if (!loginInfo.password) {
        this.$message.error("请输入登录密码");
        return;
      }
      postRequest("/system-ya/login",loginInfo)
          .then(response =>{
            if(response){
              this.$store.commit('CHANGESTORE',true);
              if(this.login_form.username === "tjlkgly") {
                this.$router.push('/kasnshituIpad');
              }else {
                              this.$router.push('/index');

              }

            }
          })
      event.preventDefault();
    },

    onRegister: function () {
      this.clearRegisterForm();
      this.registerDialogVisible = true;
    },
    clearRegisterForm: function () {
      this.registerForm = {
        phoneNumber: "",
        verificationCode: ""
      };
    },
    onSubmit: function () {
      let loginInfo = this.login_form;
      if (!loginInfo.username) {
        this.$message.error("请输入用户名");
        return;
      }
      if (!loginInfo.password) {
        this.$message.error("请输入登录密码");
        return;
      }
      let me = this;
      $.ajax({
        url: "/api/nbiot/login",
        type: 'POST',
        data: JSON.stringify(loginInfo),
        success: function (result) {
          window.location.href = "index.vue";
        }
      });

      event.preventDefault();
    },
    sendMsg: function () {
      let me = this;
      this.$refs.registerForm.validateField("phoneNumber", (valid) => {
        if (!valid) {
          me.allowedSendSms = true;
          $.ajax({
            url: "/app/auth/sendValidateCode",
            type: 'POST',
            data: JSON.stringify({
              data:{
                mobile:"R6TkqMiM0eNMMEX60h9A1Q=="
              }
            }),
            success: function (result) {
              if(eval(result.data)){
                me.$notify({
                  title: '提示',
                  message: '验证码发送成功'
                });
              } else {
                me.$notify({
                  title: '提示',
                  message: '发送失败，请重试',
                  duration: 0
                });
              }
            }
          });
          let i = 10;
          let sendInterval = setInterval(function () {
            me.sendText = i+" 秒";
            i--;
            if(i===0){
              me.sendText = "发送";
              me.allowedSendSms = false;
              clearInterval(sendInterval);
            }
          },1000);
        }
      });
    },
    initPageHeight: function () {
      this.pageHeight = $(window).height();
    },
    loginByPhone:function () {
      let me = this;
      let loginInfo = {
        phone:this.registerForm.phoneNumber,
        code:this.registerForm.verificationCode
      };
      this.$refs.registerForm.validate((valid) => {
        if (valid) {
          $.ajax({
            url: "/app/login",
            type: 'POST',
            data: JSON.stringify(loginInfo),
            success: function (result) {
              console.log(result.data);
              me.$notify({
                title: '提示',
                message: '注册成功'
              });
              window.location.href = "index";
            }
          });
        }
      });
    }
  },
  // 登录成功后销毁事件
  destroyed () {
    window.removeEventListener('keydown', this.keyDown, false);
    // 登录成功后清除事件监听
    $("#password").unbind("keydown");
  }


}
</script>


<style scoped>


.login-box {
  /*border-radius: 10px;*/
  padding-top: 40px;
  padding-right: 30px;
  width: 20%;
  margin-left: 62%;
  /*margin-top: 8.11%;*/
  /*padding-bottom: 1px;*/
  /*background-color: rgba(255, 255, 255, 0.9);*/
  /*box-shadow: 0px 0px 20px 0px #ffffff;*/
}

.login-box input{
  line-height: normal;
}

#login-form .el-form-item__label {
  color: #606266;
}

.login-bg{
  background-image: url('../../public/static/asert/image/ui/login-imag.jpg');
  /*display: flex;*/
  /*justify-content: center;*/
  /*align-items: center;*/
  height: 100%;
  position: fixed;
  width: 100%;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
.login-btn{
  margin-top: 30px;
  width: 100%;
  height: 40px;
  background: linear-gradient(98deg, #2C70F7, #6D5CEC);
  border-radius: 42px;
}
.login-title{
  text-align: center;
  height: 70px;
  font-size: 36px;
  font-family: FZZongYi-M05S;
  font-weight: 400;
  color: #484848;
}
.com-info{
  width: 100%;
  text-align: center;
  color: #909399;
  font-size: 10px;
  background-color: rgba(255, 255, 255, 0.9);
  box-shadow: 0px 0px 20px 0px #ffffff;
  margin-top: 30px;
  border-radius: 10px;
  padding-top: 5px;
  padding-bottom: 5px;
}
</style>
